import { render, staticRenderFns } from "./address.vue?vue&type=template&id=dceddb6a&scoped=true"
import script from "./address.vue?vue&type=script&lang=js"
export * from "./address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a947b4d37137bf79d4abbd1caef86e24/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dceddb6a",
  null
  
)

export default component.exports